// Brand Color Constants for Admin Dashboard
// Based on BluePill AI brand theme

export const BRAND_COLORS = {
  // Primary brand colors
  primary: '#03e8d3',
  primaryDark: '#02b9a8',
  primaryLight: '#66f0e2',
  primary50: '#e6fcfa',
  primary100: '#ccfaf5',
  primary500: '#03e8d3',
  primary600: '#02b9a8',
  
  // Secondary colors
  secondary: '#028b7e',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  
  // Special colors for token types
  purple: '#8B5CF6',
  teal: '#14B8A6',
  pink: '#EC4899',
  orange: '#F97316',
  indigo: '#6366F1',
  
  // Neutrals
  background: '#f1efe7',
  white: '#FFFFFF',
  gray50: '#F9FAFB',
  gray100: '#F3F4F6',
  gray200: '#E5E7EB',
  gray300: '#D1D5DB',
  gray400: '#9CA3AF',
  gray500: '#6B7280',
  gray600: '#4B5563',
  gray700: '#374151',
  gray800: '#1F2937',
  gray900: '#111827',
};

// Chart color palette (for consistent visualization)
export const CHART_COLORS = {
  primary: BRAND_COLORS.primary,
  secondary: BRAND_COLORS.secondary,
  success: BRAND_COLORS.success,
  warning: BRAND_COLORS.warning,
  danger: BRAND_COLORS.danger,
  purple: BRAND_COLORS.purple,
  teal: BRAND_COLORS.teal,
  orange: BRAND_COLORS.orange,
};

// Token type colors
export const TOKEN_COLORS = {
  input: BRAND_COLORS.primary,
  output: BRAND_COLORS.success,
  cached: BRAND_COLORS.warning,
  thoughts: BRAND_COLORS.purple,
  tools: BRAND_COLORS.teal,
};

// Chart color array (for multi-series)
export const CHART_COLOR_ARRAY = [
  BRAND_COLORS.primary,
  BRAND_COLORS.success,
  BRAND_COLORS.warning,
  BRAND_COLORS.danger,
  BRAND_COLORS.purple,
  BRAND_COLORS.teal,
  BRAND_COLORS.orange,
  BRAND_COLORS.pink,
];

